<template>
  <el-form
    ref="forgotForm"
    :model="forgotForm"
    :rules="loginRules"
    class="login-form"
    auto-complete="on"
    label-position="left"
    @submit.prevent.native="handleForgotPassword"
  >
    <div class="my-9 text-base font-medium">
      パスワード再設定のリクエスト
    </div>
    <div class="please">
      パスワードを再設定するには、メールアドレスを入力してください
    </div>
    <div v-if="timerCount > 0" class="please">
      あなたのメールアドレスにメールを送信しました。
      <span>
        <b class="text-gray-500">{{ timerCount }}</b>
        秒後で再送信できます。
      </span>
    </div>
    <div id="countdown"></div>

    <el-form-item prop="email" class="form-item">
      <span class="svg-container">
        <img src="@/assets/login/card.png" alt="" />
      </span>
      <el-input
        v-model="forgotForm.email"
        name="email"
        type="text"
        :placeholder="'メールアドレス'"
      />
    </el-form-item>
    <div class="flex mt-5">
      <el-button
        style="width: 100%; color: black; background: #FFFFFF;"
        @click="$router.push({ name: 'login' })"
      >
        <span class="font-normal text-base ">キャンセル</span>
      </el-button>
      <el-button
        :loading="loading"
        style="width: 100%; color: black; background: #FDB92C;"
        @click.native.prevent="handleForgotPassword"
        :disabled="!forgotForm.email || timerCount > 0"
      >
        <span class="font-normal text-base ">送信</span>
      </el-button>
    </div>
  </el-form>
</template>

<script>
import loginMixin from "@/mixins/login.mixin";
import { mapGetters, mapActions } from "vuex";
export default {
  mixins: [loginMixin],
  data: function() {
    return {
      timerCount: 0,
      loading: false,
      forgotForm: {
        email: "",
      },
    };
  },
  methods: {
    ...mapActions("auth", ["forgotPassword"]),
    async handleForgotPassword() {
      this.$refs.forgotForm.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          const res = await this.forgotPassword(this.forgotForm.email);
          if (res.success) {
            this.$notify.success({
              title: "成功",
              dangerouslyUseHTMLString: true,
              message: `${res.data.email} に送信されました <br/> メールを確認してください`,
            });
            this.timerCount = 30;
          } else {
            this.$notify.error({
              title: "エラー",
              message: res.data.email,
            });
          }
          this.loading = false;
        }
      })

    },
  },

  computed: {
    ...mapGetters("auth", ["getTimerCountDown"]),
  },
  beforeMount() {
      this.$router.push({ name: "login" });
  },

  created() {
    this.timerCount = this.getTimerCountDown;
  },

  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
            this.$store.dispatch("auth/setTimerCountDown", this.timerCount);
          }, 1000);
        }
      },
    },
  },
};

</script>

<style scoped>
.please {
  font-weight: 400;
  font-size: 14px;
  color: #00000073;
}
.form-item {
  margin-top: 16px;
}
</style>
